import React, { createContext, useState } from "react";

export const TotalTeamPlayedContext = createContext();

export const TotalTeamPlayedProvider = ({ children }) => {
  const [totalTeamPlayed, setTotalTeamPlayed] = useState(0);
  return (
    <TotalTeamPlayedContext.Provider
      value={{ totalTeamPlayed, setTotalTeamPlayed }}
    >
      {children}
    </TotalTeamPlayedContext.Provider>
  );
};
